/* Pop-up quiz: "What's your hat doing to you?" -> reply + email -> code.
   Saves the answer to Klaviyo as "Hat Check Concern" (same field as the full Hat Check quiz). */
(function () {
  var root = document.querySelector('[data-hp]'), cfgEl = document.getElementById('hp-config');
  if (!root || !cfgEl) return;
  var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  /* restock: once it's live, lead with it (small label + line under the headline) */
  if (document.documentElement.classList.contains('rs-live')) {
    if (cfg.rsEyebrow) { cfg.eyebrow = cfg.rsEyebrow; cfg.eyebrow2 = cfg.eyebrow2 || cfg.rsEyebrow; }
    if (cfg.rsIntroSub) cfg.introSub = cfg.rsIntroSub;
  }
  var stage = root.querySelector('[data-hp-stage]'), box = root.querySelector('.hp__box'), tab = document.querySelector('[data-hp-tab]');
  var KEY = 'hatsy_popup', pick = null, lastFocus = null;

  /* ---------- memory: dismissed / signed up ---------- */
  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function save(o) { try { localStorage.setItem(KEY, JSON.stringify(Object.assign(load(), o))); } catch (e) {} }
  var mem = load();
  var signedUp = !!mem.joined;
  var snoozed = mem.closed && (Date.now() - mem.closed) < (cfg.days || 7) * 864e5;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- icons (same drawings as the Hat Check) ---------- */
  var ICONS = {
    thinning: '<path d="M14 40 C 10 30, 12 16, 24 12 C 34 9, 40 16, 38 26 C 37 32, 34 34, 34 40"/><path d="M16 22 C 22 18, 30 17, 37 21" stroke="#9a958e" stroke-dasharray="1.5 2.5"/>',
    breakouts: '<path d="M8 20 C 16 14, 32 14, 40 20"/><path d="M6 20 H 42" stroke="#d9c7ae" stroke-width="4"/><circle cx="17" cy="28" r="1.6"/><circle cx="25" cy="31" r="1.6"/><circle cx="31" cy="27" r="1.6"/>',
    scalp: '<path d="M8 30 C 14 24, 20 36, 26 30 S 38 24, 42 30"/><path d="M8 38 C 14 32, 20 44, 26 38 S 38 32, 42 38" stroke="#9a958e"/><path d="M18 12 l2 6 M26 10 l0 7 M34 12 l-2 6"/>',
    frizz: '<path d="M12 36 C 10 26, 16 22, 14 14 M20 36 C 18 26, 26 22, 22 12 M28 36 C 26 26, 34 22, 30 12 M36 36 C 34 28, 40 24, 38 16"/>',
    heat: '<circle cx="18" cy="16" r="5"/><path d="M18 6v2M18 24v2M8 16h2M26 16h2" stroke="#9a958e"/><path d="M33 24 c -5 7 -5 12 0 12 c 5 0 5 -5 0 -12z" fill="#d6e1e8"/>',
    comfort: '<path d="M10 30 C 10 20, 20 14, 28 16 C 36 18, 40 26, 36 32 C 30 38, 18 38, 10 30 Z" fill="#d9c7ae" fill-opacity=".45"/><path d="M16 28 C 22 24, 30 24, 34 28" stroke="#9a958e"/>'
  };
  function icon(k) { return '<svg viewBox="0 0 48 48" fill="none" stroke="#1c1b19" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (ICONS[k] || '') + '</svg>'; }
  function eb(text, step) {
    var dots = step ? '<span class="hp__steps" aria-hidden="true"><i class="on"></i><i' + (step > 1 ? ' class="on"' : '') + '></i></span>' : '';
    if (!text) return '';
    return '<div class="hp__eb">' + esc(text) + dots + '</div>';
  }
  /* heading: first line big, any lines after it smaller underneath; *stars* = brown */
  function rich(s) {
    var lines = String(s || '').trim().split(/\r?\n/).filter(function (l) { return l.trim(); }).map(function (l) {
      return esc(l.trim()).replace(/\*([^*]+)\*/g, '<em class="hp__acc">$1</em>');
    });
    return (lines.shift() || '') + (lines.length ? '<span class="hp__h-sm">' + lines.join('<br>') + '</span>' : '');
  }
  var concerns = (cfg.concerns || []).filter(function (c) { return c.label; });

  /* phones: no lonely last word. Lines are balanced in CSS; this also glues the last two words together. */
  function unwiden() {
    stage.querySelectorAll('.hp__h, .hp__h-sm, .hp__lede, .hp__sub, .hp__fact, .hp__fine, .hp__next, .hp__o span, .hp__pill').forEach(function (el) {
      if ((el.textContent || '').trim().split(/\s+/).length < 4) return;
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), t, last = null;
      while ((t = w.nextNode())) if (t.nodeValue.trim()) last = t;
      if (!last || (last.parentNode && last.parentNode.classList && last.parentNode.classList.contains('hp__acc'))) return;
      var v = last.nodeValue, m = v.match(/^([\s\S]*\S)\s+(\S+\s*)$/);
      if (m) last.nodeValue = m[1] + '\u00a0' + m[2];
    });
  }
  if ('MutationObserver' in window) new MutationObserver(unwiden).observe(stage, { childList: true });

  /* ---------- Google Sheet: one row per answer, sent once (with the email if they sign up) ---------- */
  var SESSION = 'pu_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7), rowSent = false, rowEmail = '';
  function sendRow() {
    if (rowSent || !pick || !cfg.sheet || !/^https:\/\/script\.google\.com\//.test(cfg.sheet)) return;
    rowSent = true;
    var QS = new URLSearchParams(location.search);
    var row = { key: cfg.sheetKey || '', session: SESSION, source: 'Pop-up', concern: pick.save || pick.label, frequency: '', where: '', hair: '', style: '',
      recommended: '', email: rowEmail, gave_email: rowEmail ? 'yes' : 'no',
      ad_concern: QS.get('concern') || '', utm_source: QS.get('utm_source') || '', utm_medium: QS.get('utm_medium') || '', utm_campaign: QS.get('utm_campaign') || '', utm_content: QS.get('utm_content') || '',
      device: window.innerWidth < 768 ? 'mobile' : 'desktop', referrer: location.pathname };
    try { fetch(cfg.sheet, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(row) }).catch(function () {}); } catch (e) {}
  }
  window.addEventListener('pagehide', sendRow);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') sendRow(); });

  /* ---------- screens ---------- */
  /* answers: "comfort" can be the big option on top, the pain points below */
  function optBtn(c, big) {
    var i = concerns.indexOf(c);
    return '<button type="button" class="hp__o' + (big ? ' hp__o--big' : '') + (pick === c ? ' is-sel' : '') + '" data-i="' + i + '">' + (big ? '' : icon(c.key)) +
      (cfg.tag ? '<em class="hp__tag keep-caps">' + esc(cfg.tag) + '</em>' : '') +
      '<span>' + esc(c.label) + (big && cfg.featureSub ? '<small>' + esc(cfg.featureSub) + '</small>' : '') + '</span></button>';
  }
  function optsHtml() {
    var top = cfg.feature ? concerns.filter(function (c) { return c.key === 'comfort'; })[0] : null;
    if (!top) return '<div class="hp__opts">' + concerns.map(function (c) { return optBtn(c, false); }).join('') + '</div>';
    var rest = concerns.filter(function (c) { return c !== top; });
    /* the two "wide" answers go last, in the order chosen in the settings */
    var wide = (cfg.wide || []).filter(Boolean);
    var small = rest.filter(function (c) { return wide.indexOf(c.key) < 0; });
    var big = wide.map(function (k) { return rest.filter(function (c) { return c.key === k; })[0]; }).filter(Boolean);
    var ordered = small.concat(big);
    var cls = (small.length === 3 && big.length === 2) ? ' hp__opts--3x2' : '';
    if (cfg.featurePos === 'above') {
      /* the slim "comfort" option first, then the issues */
      var i1 = concerns.indexOf(top);
      return '<button type="button" class="hp__none hp__none--top' + (pick === top ? ' is-sel' : '') + '" data-i="' + i1 + '">' + esc(cfg.noneLabel || top.label) + '</button>' +
        '<div class="hp__opts hp__opts--rest hp__opts--n' + ordered.length + cls + '">' + ordered.map(function (c) { return optBtn(c, false); }).join('') + '</div>';
    }
    if (cfg.featurePos === 'bottom') {
      /* issues first; "comfort" becomes a slim way out underneath */
      var i0 = concerns.indexOf(top);
      return '<div class="hp__opts hp__opts--rest hp__opts--n' + ordered.length + cls + '">' + ordered.map(function (c) { return optBtn(c, false); }).join('') + '</div>' +
        '<button type="button" class="hp__none' + (pick === top ? ' is-sel' : '') + '" data-i="' + i0 + '">' + esc(cfg.noneLabel || top.label) + '</button>';
    }
    return '<div class="hp__opts hp__opts--top">' + optBtn(top, true) + '</div>' +
      (cfg.moreLabel ? '<div class="hp__or">' + esc(cfg.moreLabel) + '</div>' : '') +
      '<div class="hp__opts hp__opts--rest hp__opts--n' + ordered.length + cls + '">' + ordered.map(function (c) { return optBtn(c, false); }).join('') + '</div>';
  }
  /* the floating hat: one photo, or several colours that switch every few seconds */
  var hatTimer = null;
  function stopHats() { if (hatTimer) { clearInterval(hatTimer); hatTimer = null; } }
  function hatHtml() {
    var list = (cfg.hats && cfg.hats.length) ? cfg.hats : (cfg.hat ? [cfg.hat] : []);
    if (!list.length) return '';
    return '<span class="hp__hat" aria-hidden="true"><span class="hp__hat-f">' + list.map(function (u, i) {
      var now = i === 0 || warmed.indexOf(u) > -1;
      return '<img class="' + (i === 0 ? 'is-on' : '') + '" ' + (now ? 'src' : 'data-src') + '="' + esc(u) + '" alt="" width="360" height="524"' + (i === 0 ? ' fetchpriority="high"' : ' decoding="async"') + '>';
    }).join('') + '</span></span>';
  }
  function startHats() {
    stopHats();
    var imgs = stage.querySelectorAll('.hp__hat img');
    if (imgs.length < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    [].forEach.call(imgs, function (im) { if (im.dataset.src) { im.src = im.dataset.src; im.removeAttribute('data-src'); } });
    var n = 0;
    hatTimer = setInterval(function () {
      if (!document.body.contains(imgs[0])) return stopHats();
      var next = (n + 1) % imgs.length;
      if (!imgs[next].complete) return;
      /* clean cut to the next colour (same photo, so the hat stays put) */
      imgs[next].classList.add('is-on'); imgs[n].classList.remove('is-on'); n = next;
    }, cfg.hatEvery || 2000);
  }
  function hatLineHtml() {
    if (!cfg.hatLine || !hatHtml()) return '';
    /* "Main line. …aside" -> the part after the ellipsis sits underneath, smaller, like a wink */
    var t = String(cfg.hatLine), m = t.match(/^(.*?)\s*(?:\u2026|\.\.\.)\s*(.+)$/);
    var main = m && m[1] ? m[1] : t, aside = m && m[1] ? '\u2026' + m[2] : '';
    return '<p class="hp__hatline' + (cfg.hatLineStyle === 'caps' ? ' hp__hatline--caps' : '') + '">' + rich(main) + (aside ? '<span class="hp__hatline-aside">' + rich(aside) + '</span>' : '') + '</p>';
  }
  /* two-step mode, screen 1: the hook (headline, floating hat, one big "yes" button) */
  function showIntro() {
    stopHats();
    stage.innerHTML = '<div class="hp__intro">' + eb(cfg.eyebrow, 1) + '<h2 class="hp__h hp__h--q">' + rich(cfg.introTitle || cfg.title) + '</h2>' +
      (cfg.introSub ? '<p class="hp__introsub">' + rich(cfg.introSub) + '</p>' : '') +
      hatHtml() + hatLineHtml() +
      (cfg.introText ? '<p class="hp__lede hp__lede--intro">' + rich(cfg.introText) + '</p>' : '') +
      '<button type="button" class="hp__btn hp__btn--go keep-caps" data-hp-go><span>' + esc(cfg.introButton || 'Get my 15% off') + '</span></button>' +
      (cfg.introFine ? '<p class="hp__introfine">' + esc(cfg.introFine) + '</p>' : '') +
    '</div>';
    stage.querySelector('[data-hp-go]').addEventListener('click', function () {
      stopHats(); started = true;
      kl('track', 'Pop-up Quiz Started', {});
      showQuestion();
    });
    setTimeout(startHats, 900);
  }
  var started = false;
  function showQuestion() {
    stopHats();
    var two = !!cfg.intro;
    stage.innerHTML = '<div>' + eb(cfg.eyebrow, 1) +
      (two
        ? '<h2 class="hp__h hp__h--q hp__h--q2">' + rich(cfg.qTitle || cfg.title).replace(/\?\s+(?=\S)/g, '?<br>').replace(/^([^<:]{3,32}):\s+(\S)/, function (m, k, c) { return '<span class="hp__qk">' + k + '</span>' + c.toUpperCase(); }) + '</h2>' +
          (cfg.qSub ? '<p class="hp__lede hp__lede--q2">' + rich(cfg.qSub).replace(/([.?!])\s+(?=\S)/g, '$1<br>').replace(/,\s+/, ',<br>') + '</p>' : '')
        : '<h2 class="hp__h hp__h--q">' + rich(cfg.title) + '</h2>' +
          (hatHtml() || (cfg.sub ? '<span class="hp__rule" aria-hidden="true"></span>' : '')) + hatLineHtml() +
          (cfg.sub ? '<p class="hp__lede">' + rich(cfg.sub).replace(/\?\s+(?=\S)/g, '?<br>') + '</p>' : '')) +
      optsHtml() +
      (cfg.no ? '<button type="button" class="hp__no" data-hp-close>' + esc(cfg.no) + '</button>' : '') + '</div>';
    stage.querySelectorAll('.hp__o, .hp__none').forEach(function (b) {
      b.addEventListener('click', function () {
        stopHats(); b.classList.add('is-sel'); pick = concerns[+b.dataset.i];
        kl('track', 'Pop-up Quiz Answered', { concern: pick.key, concern_label: pick.save || pick.label });
        setTimeout(showEmail, 180);
      });
    });
    setTimeout(startHats, 900);
  }
  function showEmail() {
    var c = pick;
    var off = String(cfg.offer || '');
    off = c.benefit ? off.replace(/\[benefit\]/gi, c.benefit) : off.replace(/\s*(?:and|,|\+)?\s*\[benefit\]/gi, '');
    var offer = esc(off).replace(/\[concern\]/gi, esc(c.short || String(c.label).toLowerCase())).replace(/\*([^*]+)\*/g, '<b>$1</b>');
    /* bold offer on its own line, the benefit underneath (no awkward mid-phrase wraps) */
    offer = offer.replace(/<\/b>\s+(?=\S)/, '</b> <br class="hp__br-m">');
    stage.innerHTML = '<div>' + eb(cfg.eyebrow2 || cfg.eyebrow, 2) +
      '<div class="hp__pill">' + icon(c.key) + esc(c.label) + '<button type="button" data-hp-change>change</button></div>' +
      '<h2 class="hp__h">' + (cfg.reveal && c.key !== 'comfort' ? '<span class="hp__qk">' + esc(cfg.reveal) + '</span>' : '') + esc(c.title).replace(/([.?!])\s+(?=\S)/g, '$1<br>') + '</h2>' +
      (c.text ? '<div class="hp__fact">' + esc(c.text).replace(/\*([^*]+)\*/g, '<b>$1</b>').replace(/Hatsy Silk-Tech/g, 'Hatsy\u00a0Silk\u2011Tech') + '</div>' : '') +
      (offer ? '<p class="hp__sub">' + offer + '</p>' : '') +
      '<form class="hp__form" novalidate><input class="hp__in" type="email" name="email" placeholder="your email" autocomplete="email" aria-label="Email" required>' +
      '<p class="hp__err" hidden>Please enter a valid email.</p>' +
      '<button type="submit" class="hp__btn keep-caps"><span>' + esc(cfg.button) + '</span></button></form>' +
      (cfg.fine ? '<p class="hp__fine">' + esc(cfg.fine) + '</p>' : '') + '</div>';
    stage.querySelector('[data-hp-change]').addEventListener('click', showQuestion);
    var form = stage.querySelector('form'), input = form.querySelector('input'), err = form.querySelector('.hp__err'), btn = form.querySelector('button');
    if (window.matchMedia('(min-width: 768px)').matches) setTimeout(function () { input.focus(); }, 60);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = input.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.hidden = false; input.focus(); return; }
      err.hidden = true; btn.disabled = true;
      subscribe(email, c).then(function () { save({ joined: Date.now(), concern: c.key }); try { localStorage.setItem('hatsy_email', email); } catch (e) {} rowEmail = email; sendRow(); signedUp = true; if (tab) tab.hidden = true; showDone(); },
        function () { btn.disabled = false; err.textContent = 'Something went wrong. Please try again.'; err.hidden = false; });
    });
  }
  function showDone() {
    var c = pick, code = cfg.code;
    stage.innerHTML = '<div>' + eb(cfg.doneEyebrow) + '<h2 class="hp__h">' + esc(cfg.doneTitle) + '</h2>' +
      (code ? '<div class="hp__code"><small>Your code</small><strong>' + esc(code) + '</strong><button type="button" data-hp-copy>Copy code</button></div>'
            : '<p class="hp__sub">' + esc(cfg.doneNoCode) + '</p>') +
      '<a class="hp__btn keep-caps" href="' + esc(c.url) + '"><span>' + esc(c.shop) + '</span></a>' +
      (cfg.quizLabel ? '<a class="hp__ghost keep-caps" href="' + esc(cfg.quizUrl) + '?concern=' + encodeURIComponent(quizKey(c.key)) + '"><span>' + esc(cfg.quizLabel) + '</span>' + (cfg.quizTime ? '<span class="nav-quiz-tag hp__time">' + esc(cfg.quizTime) + '</span>' : '') + '</a>' : '') +
      (cfg.doneText ? '<div class="hp__next"><span>&#10003;</span>' + esc(cfg.doneText) + '</div>' : '') + '</div>';
    var cp = stage.querySelector('[data-hp-copy]');
    if (cp) cp.addEventListener('click', function () {
      try { navigator.clipboard.writeText(code).then(function () { cp.textContent = 'Copied'; }); } catch (e) {}
    });
  }
  /* the full quiz's ?concern= link names */
  function quizKey(k) { return { thinning: 'hairloss', breakouts: 'acne', scalp: 'dandruff', frizz: 'dryhair', heat: 'sweat', comfort: 'comfort' }[k] || k; }

  /* ---------- Klaviyo ---------- */
  function kl() { var a = [].slice.call(arguments); try { (window.klaviyo = window.klaviyo || []).push(a); } catch (e) {} }
  function companyId() {
    if (cfg.company) return Promise.resolve(cfg.company);
    var s = document.querySelector('script[src*="klaviyo.js?company_id="], script[src*="klaviyo.js?"]');
    var m = s && s.src.match(/company_id=([A-Za-z0-9]+)/);
    if (m) return Promise.resolve(m[1]);
    try { if (window.klaviyo && typeof window.klaviyo.account === 'function') return Promise.resolve(window.klaviyo.account()); } catch (e) {}
    return Promise.resolve('');
  }
  function subscribe(email, c) {
    var props = { 'Hat Check Concern': c.save || c.label, 'Hat Check Concern Key': c.key, 'Hat Check Source': 'Pop-up quiz', 'Hat Check Date': new Date().toISOString() };
    kl('identify', Object.assign({ email: email }, props));
    kl('track', 'Pop-up Quiz Signup', { concern: c.key, concern_label: c.save || c.label });
    var list = cfg.list || 'VvNzBE';
    return companyId().then(function (id) {
      id = id || 'W52RWG';
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(id), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: {
          custom_source: 'Pop-up quiz',
          profile: { data: { type: 'profile', attributes: { email: email } } } },
          relationships: { list: { data: { type: 'list', id: list } } } } })
      }).then(function (r) { if (!r.ok && r.status !== 202) throw new Error('klaviyo ' + r.status); });
    });
  }

  /* undo any scroll lock left behind (ours, or Klaviyo's hidden pop-up) when nothing should be locking the page */
  function unlock() {
    if (!root.hidden && root.classList.contains('is-open')) return;
    if (document.querySelector('.drawer.is-open, [data-cart-drawer].is-open, .is-open[class*="drawer"]')) return;
    if (document.documentElement.classList.contains('hp-lock')) document.documentElement.classList.remove('hp-lock');
    [document.documentElement, document.body].forEach(function (el) {
      if (el.style.overflow === 'hidden') el.style.overflow = '';
      if (el.style.overflowY === 'hidden') el.style.overflowY = '';
      if (el.style.position === 'fixed') { var top = parseInt(el.style.top || '0', 10); el.style.position = ''; el.style.top = ''; el.style.width = ''; if (top) window.scrollTo(0, -top); }
      if (el.style.touchAction === 'none') el.style.touchAction = '';
    });
    [document.documentElement, document.body].forEach(function (el) {
      [].slice.call(el.classList).forEach(function (c) { if (/klaviyo|^kl-|prevent-?(body-)?scroll|no-?scroll|scroll-?lock/i.test(c)) el.classList.remove(c); });
    });
  }
  /* Klaviyo can lock the page a moment after its (hidden) pop-up loads, so watch <html> and <body> for a lock and lift it.
     Only these two elements are watched, so this costs nothing while scrolling. */
  if (cfg.hideKlaviyo && 'MutationObserver' in window) {
    var lockWatch = new MutationObserver(function () { if (root.hidden) unlock(); });
    lockWatch.observe(document.documentElement, { attributes: true, attributeFilter: ['style', 'class'] });
    lockWatch.observe(document.body, { attributes: true, attributeFilter: ['style', 'class'] });
  }

  /* ---------- open / close ---------- */
  function open(manual) {
    if (!root.hidden) return;
    if (!manual && (signedUp || snoozed)) return;
    if (document.querySelector('.drawer.is-open, [data-cart-drawer].is-open')) return;
    lastFocus = document.activeElement;
    if (signedUp) { pick = pick || concerns.filter(function (c) { return c.key === mem.concern; })[0] || concerns[concerns.length - 1]; showDone(); }
    else if (pick) showEmail(); else if (cfg.intro && !started) showIntro(); else showQuestion();
    root.hidden = false; document.documentElement.classList.add('hp-lock');
    if (tab) tab.hidden = true;
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); box.focus({ preventScroll: true }); }); });
    kl('track', 'Pop-up Quiz Viewed', {});
  }
  function close() {
    if (root.hidden) return;
    root.classList.remove('is-open'); document.documentElement.classList.remove('hp-lock');
    if (!signedUp) { save({ closed: Date.now() }); snoozed = true; }
    sendRow();
    setTimeout(function () { root.hidden = true; if (tab && !signedUp) tab.hidden = false; unlock(); }, 350);
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }
  root.addEventListener('click', function (e) { if (e.target.closest('[data-hp-close]')) close(); });
  document.addEventListener('keydown', function (e) {
    if (root.hidden) return;
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') {   /* keep focus inside */
      var f = [].filter.call(box.querySelectorAll('button, a[href], input'), function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  if (tab) {
    tab.addEventListener('click', function () { open(true); });
    tab.addEventListener('pointerenter', function () { warmHats(true); }, { once: true });
    tab.addEventListener('touchstart', function () { warmHats(true); }, { once: true, passive: true });
  }
  /* any link to #hatsy-offer opens it too */
  document.addEventListener('click', function (e) { var a = e.target.closest('a[href$="#hatsy-offer"]'); if (a) { e.preventDefault(); open(true); } });
  window.HatsyPopup = { open: function () { open(true); }, close: close, reset: function () { try { localStorage.removeItem(KEY); } catch (e) {} } };

  /* ---------- warm the hat photos before the pop-up opens, so the first hat is already there ---------- */
  var warmed = [];
  function hatList() { return (cfg.hats && cfg.hats.length) ? cfg.hats : (cfg.hat ? [cfg.hat] : []); }
  function warmHats(all) {
    var list = hatList(); if (!list.length) return;
    (all ? list : list.slice(0, 1)).forEach(function (u) {
      if (warmed.indexOf(u) > -1) return; warmed.push(u);
      var im = new Image(); im.decoding = 'async'; im.src = u; warmHats._keep = (warmHats._keep || []).concat(im);
    });
  }
  function warmSoon() {
    var go = function () { warmHats(false); setTimeout(function () { warmHats(true); }, 1500); };
    if (document.readyState === 'complete') setTimeout(go, 300); else window.addEventListener('load', function () { setTimeout(go, 300); }, { once: true });
  }

  /* ---------- when to show ---------- */
  if (cfg.quiet) {   /* cart and Hat Check pages: never open here */
    if (tab) tab.hidden = true;
  } else if (/[?&]popup=1\b/.test(location.search)) {   /* testing: hatsy.com/?popup=1 always shows it, fresh */
    signedUp = false; snoozed = false; pick = null; started = false; setTimeout(function () { open(true); }, 600);
  } else if (cfg.design) {   /* theme editor: show it straight away so it can be styled */
    signedUp = false; snoozed = false; setTimeout(function () { open(true); }, 400);
  } else if (!signedUp) {
    if (tab) tab.hidden = !snoozed;
    if (!snoozed) {
      warmSoon();
      var t = setTimeout(function () { open(false); }, Math.max(0, +cfg.delay || 0) * 1000);
      if (cfg.exit && window.matchMedia('(pointer: fine)').matches) {
        document.addEventListener('mouseout', function onOut(e) {
          if (!e.relatedTarget && e.clientY <= 0) { clearTimeout(t); document.removeEventListener('mouseout', onOut); open(false); }
        });
      }
    }
    /* someone Klaviyo already knows (e.g. signed up through the Hat Check) does not get the pop-up */
    try { if (window.klaviyo && typeof window.klaviyo.isIdentified === 'function') window.klaviyo.isIdentified().then(function (yes) { if (yes && root.hidden) { signedUp = true; if (tab) tab.hidden = true; } }); } catch (e) {}
  }

  /* ---------- hide Klaviyo's own pop-up, flyout and side tab while this one is on ---------- */
  if (cfg.hideKlaviyo) {
    document.documentElement.classList.add('hp-kl-off');
    /* Klaviyo pop-ups, flyouts and teasers. Embedded forms (e.g. in the footer) are left alone: only things inside a fixed overlay are hidden. */
    var MARK = '[role="dialog"][aria-label*="popup" i], [role="dialog"][aria-label*="flyout" i], [aria-label*="popup form" i], [aria-label*="flyout form" i], [data-testid*="POPUP"], [data-testid*="FLYOUT"], [data-testid*="teaser" i], [class*="kl-teaser"], [class*="klaviyo-form"], [class*="kl-private"]';
    var fixedTop = function (el) {
      var top = null, n = el;
      while (n && n.nodeType === 1 && n !== document.body && n !== document.documentElement) {
        var p = getComputedStyle(n).position;
        if (p === 'fixed') top = n;
        n = n.parentElement || (n.getRootNode && n.getRootNode().host) || null;
      }
      return top;
    };
    var watch = 'MutationObserver' in window ? new MutationObserver(function (ms) {
      ms.forEach(function (m) { if (m.target.style && m.target.style.getPropertyValue('display') !== 'none') m.target.style.setProperty('display', 'none', 'important'); });
    }) : null;
    var kill = function (el) {
      if (!el || el === root || el.contains(root) || el === tab || el.hasAttribute('data-hp-hid')) return;
      if (el.matches('.drawer, [data-cart-drawer], header, nav, [class*="drawer"]')) return;
      el.style.setProperty('display', 'none', 'important');
      el.setAttribute('data-hp-hid', '');
      if (watch) watch.observe(el, { attributes: true, attributeFilter: ['style'] });   /* if Klaviyo shows it again, hide it again */
      unlock();
    };
    var scan = function (scope) {
      if (!scope.querySelectorAll) return;
      if (scope.matches && scope.matches(MARK)) { var t0 = fixedTop(scope); if (t0) kill(t0); }
      scope.querySelectorAll(MARK).forEach(function (el) { var t = fixedTop(el); if (t) kill(t); });
      var h = scope.shadowRoot ? [scope] : [];
      h.forEach(function (x) { if (x.shadowRoot.querySelector('[class*="klaviyo"], [class*="kl-private"]') && x.shadowRoot.querySelector('[role="dialog"], [aria-label*="popup" i], [aria-label*="flyout" i]')) kill(x); });
    };
    var sweep = function () {
      scan(document);
      [].forEach.call(document.body.children, function (x) { if (x.shadowRoot) scan(x); });
    };
    sweep();
    [800, 2000, 4000, 7000, 12000, 20000].forEach(function (ms) { setTimeout(sweep, ms); });
    /* only look at newly added elements (cheap), never on scroll */
    if ('MutationObserver' in window) new MutationObserver(function (ms) {
      ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); }); });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
